import {
    LoadingManager,
    TextureLoader,
    sRGBEncoding,
    LinearEncoding,
    WebGLRenderer,
    MeshBasicMaterial,
    MeshStandardMaterial,
    MeshPhysicalMaterial,
    Color,
    DoubleSide,
    AdditiveBlending
} from "three";

import { isM } from "./alpha"


// ---------------------------------------------------------------------------

const maxAnisotropy = new WebGLRenderer().capabilities.getMaxAnisotropy()

const manager = new LoadingManager()
const textureLoader = new TextureLoader(manager)

export let texturesData = {
    loaded: 0,
    total: 0,
    managerState: 'Pending',
    size: {
        raw: [ ],
        total: 0,
        percent: 0
    },
}

manager.onStart = (url, itemsLoaded, itemsTotal) => {
    // console.log( 'Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
    texturesData.managerState = 'Loading'
}
manager.onProgress = (url, itemsLoaded, itemsTotal ) => {
    // console.log( 'Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
    texturesData.loaded = itemsLoaded
    texturesData.total = itemsTotal
}
manager.onLoad = ( ) => {
    texturesData.managerState = 'Ready'
    // console.log(`Textures: ${texturesData.total}, ${(texturesData.size.total / 1024 / 1024).toFixed(2)}Mb`)
}

export function imagesLoader(tx_name, max) {
    let path = './assets/glb/textures/'
    // if(isM) path = './assets/glb/textures/min/'

    const t = textureLoader.load(`${path}${tx_name}`, 
        (img) => {
            // console.log(tx_name)
        }, 
        (xhr) => {
            // if(!texturesData.size.raw.includes( xhr.total )) texturesData.size.raw.push( xhr.total )
        },
        (error) => { console.error(`[ERROR] Image '${tx_name}'`) }
    )

    // t.encoding = encoding === 'sRGB' ? sRGBEncoding : LinearEncoding
    t.encoding = sRGBEncoding
    t.flipY = false
    t.flipX = true
    if (max) t.anisotropy = maxAnisotropy

    return t
}

/*
// ---------------------------------------------------------------------------


        // Obsolote debido a que el TextureLoader
        // ya no recibe valores de carga parcial y total
        // esperar fix


    // function loadControl() {
    //     // texturesData.size.total = 0
    //     // for (var y = 0; y < texturesData.size.raw.length; y++){
    //     //     texturesData.size.total += texturesData.size.raw[y]
    //     // }

    //     texturesData.size.percent = Math.round( (texturesData.loaded / texturesData.total) * 100)
    //     if( isNaN(texturesData.size.percent) ) texturesData.size.percent = 0

    //     if(texturesData.size.percent === 100) {
    //         texturesData.loadFinish = true
    //     }
    // }
    // let r
    // function anim() {
    //     r = requestAnimationFrame( anim )
    //     if(texturesData.loadFinish == false) {
    //         loadControl()
    //     } else {
    //         window.cancelAnimationFrame( r )
    //     }
    // }
    // anim()
    */


// ----------------------------------------------------------------------------
// Materials ------------------------------------------------------------------

export const dummy_mat = new MeshStandardMaterial({
    map: imagesLoader('dummy.png')
})


export const markerMat = new MeshBasicMaterial({
    map: imagesLoader('marker.png', true),
    transparent: true,
    opacity: 0.5,
    depthWrite: false
})
export const circleMat = new MeshBasicMaterial({
    map: imagesLoader('circle.png', true),
    transparent: true,
    opacity: 0.5,
    depthWrite: false,
    blending: AdditiveBlending
})
// markerMat.map.anisotropy = circleMat.map.anisotropy = maxAnisotropy

//

const photosBaseMat = new MeshStandardMaterial({
    roughness: 0.85,
    metalness: 0.25,
})

export const jardinCaucaMat = photosBaseMat.clone()
jardinCaucaMat.map = imagesLoader('fotos/Jardin_Cauca.jpg', true)
export const jardinChocoMat = photosBaseMat.clone()
jardinChocoMat.map = imagesLoader('fotos/Jardin_Choco.jpg', true)
export const jardinNarinoMat = photosBaseMat.clone()
jardinNarinoMat.map = imagesLoader('fotos/Jardin_Narino.jpg', true)
export const jardinValleMat = photosBaseMat.clone()
jardinValleMat.map = imagesLoader('fotos/Jardin_Valle.jpg', true)

export const caucaA_Mat = photosBaseMat.clone()
caucaA_Mat.map = imagesLoader('fotos/Cauca_A.jpg', true)
export const caucaB_Mat = photosBaseMat.clone()
caucaB_Mat.map = imagesLoader('fotos/Cauca_B.jpg', true)
export const caucaC_Mat = photosBaseMat.clone()
caucaC_Mat.map = imagesLoader('fotos/Cauca_C.jpg', true)
export const caucaD_Mat = photosBaseMat.clone()
caucaD_Mat.map = imagesLoader('fotos/Cauca_D.jpg', true)

export const chocoA_Mat = photosBaseMat.clone()
chocoA_Mat.map = imagesLoader('fotos/Choco_A.jpg', true)
export const chocoB_Mat = photosBaseMat.clone()
chocoB_Mat.map = imagesLoader('fotos/Choco_B.jpg', true)
export const chocoC_Mat = photosBaseMat.clone()
chocoC_Mat.map = imagesLoader('fotos/Choco_C.jpg', true)
export const chocoD_Mat = photosBaseMat.clone()
chocoD_Mat.map = imagesLoader('fotos/Choco_D.jpg', true)

export const valleA_Mat = photosBaseMat.clone()
valleA_Mat.map = imagesLoader('fotos/Valle_A.jpg', true)
export const valleB_Mat = photosBaseMat.clone()
valleB_Mat.map = imagesLoader('fotos/Valle_B.jpg', true)
export const valleC_Mat = photosBaseMat.clone()
valleC_Mat.map = imagesLoader('fotos/Valle_C.jpg', true)
export const valleD_Mat = photosBaseMat.clone()
valleD_Mat.map = imagesLoader('fotos/Valle_D.jpg', true)